/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundReferralItem } from './InboundReferralItem';
import {
    InboundReferralItemFromJSON,
    InboundReferralItemFromJSONTyped,
    InboundReferralItemToJSON,
    InboundReferralItemToJSONTyped,
} from './InboundReferralItem';

/**
 * 
 * @export
 * @interface ListInboundReferrals200Response
 */
export interface ListInboundReferrals200Response {
    /**
     * 
     * @type {Array<InboundReferralItem>}
     * @memberof ListInboundReferrals200Response
     */
    items: Array<InboundReferralItem>;
    /**
     * Opaque cursor for fetching the next page. Null when no more results.
     * @type {string}
     * @memberof ListInboundReferrals200Response
     */
    cursor: string;
}

/**
 * Check if a given object implements the ListInboundReferrals200Response interface.
 */
export function instanceOfListInboundReferrals200Response(value: object): value is ListInboundReferrals200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('cursor' in value) || value['cursor'] === undefined) return false;
    return true;
}

export function ListInboundReferrals200ResponseFromJSON(json: any): ListInboundReferrals200Response {
    return ListInboundReferrals200ResponseFromJSONTyped(json, false);
}

export function ListInboundReferrals200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListInboundReferrals200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(InboundReferralItemFromJSON)),
        'cursor': json['cursor'],
    };
}

export function ListInboundReferrals200ResponseToJSON(json: any): ListInboundReferrals200Response {
    return ListInboundReferrals200ResponseToJSONTyped(json, false);
}

export function ListInboundReferrals200ResponseToJSONTyped(value?: ListInboundReferrals200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(InboundReferralItemToJSON)),
        'cursor': value['cursor'],
    };
}

